import React from "react";
import { Modal, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import { useTranslate } from "../../hooks/LanguageProvider";

interface ModalDeleteProgramProps {
    show: boolean;
    onHide: () => void;
    id_programs: number[]; // tableau d'IDs
    onSuccess?: () => void;
}

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const ModalDeletePrograms: React.FC<ModalDeleteProgramProps> = ({
    show,
    onHide,
    id_programs,
    onSuccess,
}) => {
    const { translate } = useTranslate();

    const handleDelete = async () => {
        if (id_programs.length === 0) return;

        try {
            const response = await fetch(
                `${backendUrl}/api/program/delete-multiple`,
                {
                    method: "DELETE",
                    headers: { "Content-Type": "application/json" },
                    credentials: "include",
                    body: JSON.stringify({ ids: id_programs }),
                }
            );

            if (!response.ok) {
                throw new Error(translate("Error deleting programs."));
            }

            await response.json();

            toast.success(
                translate("Programs deleted successfully!"),
                {
                    position: "bottom-right",
                    autoClose: 2400,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                }
            );

            if (onSuccess) onSuccess();
            onHide();
        } catch (error) {
            console.error(error);
            toast.error(
                translate("Error deleting programs. Please try again."),
                {
                    position: "bottom-right",
                    autoClose: 2400,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                }
            );
        }
    };

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{translate("Delete")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {translate(
                    `Are you sure you want to delete ${id_programs.length} program(s)?`
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    {translate("Close")}
                </Button>
                <Button variant="danger" onClick={handleDelete}>
                    {translate("Delete")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalDeletePrograms;
